import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    domain: String,
    fullName: String,
  }

  connect() {
    const newUrl = `/find/${this.domainValue}/${encodeURIComponent(this.fullNameValue)}`
    const referrerPath = window.location.pathname

    history.replaceState({}, `Email Finder: ${this.fullNameValue} at ${this.domainValue}`, newUrl)

    // Send a page view to Google Analytics if it's a search (and not a direct link to the page)
    if (referrerPath !== newUrl) {
      App.analytics.sendPageview(
        `Email Finder: ${this.fullNameValue} at ${this.domainValue}`,
        window.location.href,
        newUrl,
      )
      App.analytics.posthog_capture("$pageview", { $current_url: newUrl })
    }
  }
}
